export default "__VITE_ASSET__a4bb2f7f__"